import { Node } from "@xyflow/react";

export enum BlocksType {
  ACTION = "Action",
  CHART_PATTERN = "Chart Pattern",
  DATA = "Data",
  INDICATOR = "Indicator",
  PATTERN = "Pattern",
  STICKY_NOTES = "Sticky notes",
  TRADING_LOGIC = "Trading logic",
  PAIR_BLOCK = "Pair Block",
}
export const negativeLogic = [
  "Lower Than",
  "Lower Than Equal To",
  "Crosses Below",
  "Below",
];

interface Output {
  id: string;
  name: string;
}

interface Params {
  box_type: "Text Box" | "Dropdown";
  max_value: number;
  min_value: number;
  default_value?: number;
  name: string;
  type: "Float";
  values?: string | null;
  for_fx?: boolean;
  check_fx?: boolean;
  forced_value?: { [key: string]: any };
}

interface Input {
  id?: string;
  name: string;
}

export interface NodeData {
  category?: string;
  description: string | null;
  is_segment_valid?: boolean;
  inputs_list?: string[];
  title?: string;
  short_name?: string;
  outputs: Output[];
  params: Params[];
  inputs: Input[];
  sources?: any[];
  unique_key?: string;
  other_inputs?: any[];
  valid?: boolean;
  type: BlocksType;
  name: string;
  color?: string;
  misc_data?: any;
  [key: string]: unknown; // 👈 Fix: Ensures compatibility with React Flow
}
export interface RawNode {
  category: string;
  description: string;
  is_segment_valid: boolean;
  name: string;
  id: string;
  short_name: string;
  outputs: { name: string }[];
  color?: string;
  params: {
    box_type: string;
    max_value: number;
    min_value: number;
    default_value: string;
    name: string;
    type: string;
    forced_value?: { [key: string]: any };
    values: string;
  }[];
  inputs: { name: string }[];
  sources: {
    box_type: string;
    max_value: number;
    min_value: number;
    name: string;
    type: string;
    values: string[];
    forced_value?: { [key: string]: any };
  }[];
  unique_key: string;
  valid: boolean;
  option: string;
  type: BlocksType;
  categoryValue: string;
}
export type CustomNode = Node<NodeData>;

export interface StrategyDataType {
  backtest_mode: string;
  canvas_data: string;
  data: string;
  hashed_user: string;
  symbol: string;
  timeframe: string;
  backtest_type: string;
  strategy_id: number;
  is_author: boolean;
  strategy_name: string;
  symbol_f_name: string;
  keygen?: string;
  broker_id?: string;
}
